import { useMemo } from 'react'
import useStoreIds from 'hooks/useStoreIds'
import { useInventoryLocationsQuery } from '../../graphql'
import { InventoryLocation } from 'inventory-web'

export default function useCurrentStore() {
	const { inventoryLocationIds } = useStoreIds()
	const { data: inventoryLocationsData, loading: isInventoryLocationsLoading } = useInventoryLocationsQuery( { variables: { inventoryLocationIds } } )

	const currentInventoryLocation = useMemo( () => {
		if ( inventoryLocationsData?.inventoryLocations && inventoryLocationsData.inventoryLocations.edges.length === 1 ) {
			return inventoryLocationsData.inventoryLocations.edges[ 0 ].node
		}
		return undefined
	}, [ inventoryLocationsData ] )

	return {
		loading: isInventoryLocationsLoading,
		currentInventoryLocation,
	}
}
